import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AuthEnums } from "models/enums";
import { TodoConstants } from "utils/constants";
import useAPIClientHelper from "./useAPIClientHelper";

/** Reads the company-scoped To-do summary for a company the user is not currently switched to. */
function useAllCompaniesTodoService() {
  const { apiClientInstance } = useAPIClientHelper();

  // The company also goes in the query string, although Core reads it from the CompanyId header only.
  // Without it every company shares one URL, and Chrome's HTTP cache lock lets just one request per URL
  // through at a time, which turns the overview's parallel loads into a serial queue.
  const getTodoSummary = (companyId: number) =>
    apiClientInstance(AuthEnums.AuthType.Company, { companyId })
      .TodoClient.TodoSummary({
        types: TodoConstants.SupportingTodoTypes,
        isSnoozed: false,
        companyId,
      } as WintSuperkollAPIModel.TodoSummaryFilter)
      .then((res) => res.data);

  return {
    getTodoSummary,
  };
}

export default useAllCompaniesTodoService;
